import { useState, useEffect } from 'react';
import { getAbTestV2 } from 'dibs-buyer-layout/exports/clientABTestV2';
import { trackAbTestV2Variant } from 'dibs-buyer-layout/exports/clientABTestV2';

export const PDP_URGENCY_PLACEMENT_AB_TEST = 'pdpUrgencyPlacement';

export const usePdpUrgencyPlacementClientVariant = (): boolean | null => {
    const [isPdpUrgencyPlacementClient, setIsPdpUrgencyPlacementVariant] = useState<boolean | null>(
        null
    );

    useEffect(() => {
        setIsPdpUrgencyPlacementVariant(
            getAbTestV2(PDP_URGENCY_PLACEMENT_AB_TEST)?.variant === 'variant'
        );
    }, []);

    return isPdpUrgencyPlacementClient;
};

export const trackPdpUrgencyPlacementAbTestVariant = (): void => {
    trackAbTestV2Variant(PDP_URGENCY_PLACEMENT_AB_TEST);
};
